/*@ngInject*/
const KeypressRestrictDirective = function () {
    return {
        restrict: 'A',
        link: function ($scope, $elem, $attr) {
            let pattern = $attr.keypressRestrict,
                regexp = new RegExp(pattern);

            $attr.$observe('keypressRestrict', function (value) {
                pattern = value;
                regexp = new RegExp(value);
            });

            function restrict(event) {
                let textFromKeypress,
                    newValue,
                    newValueValid;

                if (event.keyCode === 8) {
                    // prevent backspaces that creates a bad value

                    newValue = calculateBackspacedTextValue($elem);
                    newValueValid = regexp.test(newValue);

                    if (!newValueValid) {
                        event.preventDefault();
                    }
                } else {
                    // prevent normal keypress that creates a bad value
                    textFromKeypress = event.key;
                    newValue = calculateNewTextValue($elem, textFromKeypress);
                    newValueValid = regexp.test(newValue);

                    if (!newValueValid) {
                        event.preventDefault();
                    }
                }
            }

            function restrictPaste(event) {
                let newValue,
                    hasTrailingReturnCharacter,
                    isValid;

                if (window.clipboardData) {
                    newValue = window.clipboardData.getData('Text');
                } else if (event.originalEvent.clipboardData) {
                    newValue = event.originalEvent.clipboardData.getData('text/plain');
                }

                hasTrailingReturnCharacter = newValue[newValue.length - 1] === '↵';

                if (hasTrailingReturnCharacter) {
                    newValue = newValue.substring(0, newValue.length - 1);
                }

                isValid = regexp.test(newValue);

                if (!isValid) {
                    event.preventDefault();
                }
            }

            $elem.on('keypress', restrict);
            $elem.on('keydown', restrict);
            $elem.on('paste', restrictPaste);

            $scope.$on('$destroy', function () {
                $elem.off('keypress.keypressRestrict');
                $elem.off('keydown.keypressRestrict');
                $elem.off('paste.keypressRestrict');
            });

            /**
             * Compute new value for text element based on incoming string at current position/selection.
             *
             * @param textElement input[type=text] or textarea, jQuery wrapped or raw
             * @param incomingText new text value to be added
             * @returns {string}
             */
            function calculateNewTextValue(textElement, incomingText) {
                let wrappedElement = $(textElement),
                    rawElement = wrappedElement[0],
                    currentText = wrappedElement.val(),
                    selectStart = rawElement.selectionStart,
                    selectEnd = rawElement.selectionEnd,
                    updatedText;

                if (selectStart > selectEnd) {
                    selectEnd = rawElement.selectionStart;
                    selectStart = rawElement.selectionEnd;
                }

                updatedText = currentText.substring(0, selectStart) + incomingText + currentText.substring(selectEnd);
                return updatedText;
            }

            /**
             * Compute new value for text element based on backspace at current position/selection.
             *
             * @param textElement input[type=text] or textarea, jQuery wrapped or raw
             * @returns {string}
             */
            function calculateBackspacedTextValue(textElement) {
                let wrappedElement = $(textElement),
                    rawElement = wrappedElement[0],
                    currentText = wrappedElement.val(),
                    selectStart = rawElement.selectionStart,
                    selectEnd = rawElement.selectionEnd,
                    updatedText = '';

                if (selectStart > selectEnd) {
                    selectEnd = rawElement.selectionStart;
                    selectStart = rawElement.selectionEnd;
                }

                if (selectStart !== selectEnd) {
                    // remove the selected text
                    updatedText = currentText.substring(0, selectStart) + currentText.substring(selectEnd);
                } else if (selectStart > 0) {
                    // remove the previous character
                    updatedText = currentText.substring(0, selectStart - 1) + currentText.substring(selectStart);
                } else if (selectStart === 0) {
                    updatedText = currentText;
                }

                return updatedText;
            }
        }
    };
};

angular.module('umCore')
    .directive('keypressRestrict', KeypressRestrictDirective);
